<template lang="">
    <div class="acc-settings">
        <div class="left"></div>
        <div class="middle">
            <LoadingIndicator style="margin-top:2rem;" v-if="loading && !hasError" message="Getting Your Profile..."/>
            <SystemMessage  v-if="!loading && hasError" :message="errorMessage"/>
            <!-- <DisplaySettings/> -->
            <ChangeProfilePicture v-if="loadingSuccessful() && canAccess('enterprise')"/>   
            <ProfileInfo v-if="loadingSuccessful()"/>
            <EditEmail v-if="loadingSuccessful()"/>
            <EditPassword v-if="loadingSuccessful()"/>
            <!-- <EditUserType/> -->
            <DeactivateAccount v-if="loadingSuccessful()"/>
        </div>
        <div class="right"></div>
    </div>
</template>
<script>
import ProfileInfo from './AccountSettings/ProfileInfo.vue';
import EditEmail from './AccountSettings/EditEmail.vue';
import EditPassword from './AccountSettings/EditPassword.vue';
import EditUserType from './AccountSettings/EditUserType.vue';
import DeactivateAccount from './AccountSettings/DeactivateAccount.vue';
import ChangeProfilePicture from './AccountSettings/ChangeProfilePicture.vue';
import DisplaySettings from './AccountSettings/DisplaySettings.vue';
import LoadingIndicator from '@/components/Utility/LoadingIndicator.vue';
import SystemMessage from '@/components/Utility/SystemMessage.vue';
export default {
    components:{
        ProfileInfo,
        EditEmail,
        EditPassword,
        EditUserType,
        DeactivateAccount,
        ChangeProfilePicture,
        DisplaySettings,
        LoadingIndicator,
        SystemMessage
    },
    data(){
        return{
        loading:true,
        hasError:false,
        errorMessage:""
        }
    },
    computed:{
        authUser(){
            return this.$store.getters['auth/getAuthenticatedUser'] || null;
        }
    },
    async mounted(){
        window.scrollTo({top: 0,behavior: 'smooth'});
        await this.getProfileForEdit();

    },
    methods:{
        loadingSuccessful(){
            return !this.loading && !this.hasError;
        },
        async getProfileForEdit(){
            try{
                this.loading = true;
                await this.$store.dispatch("auth/getProfileInformationForEditAsync");
                this.loading = false;
            }catch(e){
                this.loading = false;
                this.errorMessage = e.message === "Failed to fetch" ? "Unable to get your profile information. Please check your internet connection or try refreshing the page" : e.message;
                this.hasError = true;
            }
        },
        canAccess(routeName) {
            if(this.authUser != null){
            // Resolve the route by name. `resolved.matched` contains the matched route records.
            const resolved = this.$router.resolve({ name: routeName })

            // Use the most-specific matched record (last entry) so child route meta is respected.
            const matched = resolved?.matched || []
            if (!matched.length) return false // route not found

            const record = matched[matched.length - 1]
            const meta = record.meta || {}

            // Read token from localStorage (used by guards elsewhere in the app).
            const token = localStorage.getItem('token')

            // Prefer the `authUser` from the Vuex store. Fall back to the `user` stored in localStorage.
            let user = this.authUser.value
            if (!user) {
                try {
                user = JSON.parse(localStorage.getItem('user'))
                } catch (e) {
                user = null
                }
            }

            // If the route requires authentication and there's no token, deny access.
            if (meta.requiresAuth && !token) {
                return false
            }

            // If the route specifies allowed roles, check the user's role in multiple possible shapes:
            //  - user.roles: an array of role strings
            //  - user.userType: a single role stored under `userType` (used in signup)
            //  - user.role: another common single-role field
            if (meta.roles) {
                let hasRole = false
                if (Array.isArray(user?.roles)) {
                hasRole = user.roles.some(role => meta.roles.includes(role))
                } else if (user?.userType) {
                hasRole = meta.roles.includes(user.userType)
                } else if (user?.role) {
                hasRole = meta.roles.includes(user.role)
                }
                if (!hasRole) return false
            }

            // No checks failed — allow access.
            return true
        }
        }
    }
}
</script>
<style scoped>
    .acc-settings{
        display: grid;
        grid-template-columns:1fr 1.5fr 1fr;

    }

    @media(max-width:768px){
         .acc-settings{
            margin-top:0rem;
            display: grid;
            grid-template-columns:1fr 1.5fr 1fr;

        }

        .left, .right{
            display: none;
        }

        .middle{
            grid-column: 1/4;
        }
    }
</style>